import instance from '@/services/repository';

const resource = '/taskprocedures';

export default {
    getAll() {
        return instance.get<ITaskProcedureDto[]>(`${resource}`);
    },
    getSingle(id: string) {
        return instance.get<ITaskProcedureDto>(`${resource}/${id}`);
    },
    create(payload: ITaskProcedureCreateCommand) {
        return instance.post<string>(`${resource}`, payload);
    },
    update(payload: ITaskProcedureUpdateCommand) {
        return instance.put(`${resource}/${payload.id}`, payload);
    },
    delete(id: string) {
        return instance.delete(`${resource}/${id}`);
    },
    start(payload: any) {
        return instance.post(`${resource}/start`, payload);
    },
};
